var stickyHeader = {
    scrollHandler: function() {
        var self  = this,
        scrollTop = $( window ).scrollTop();

        if ( $( document.body ).hasClass( 'disable-sticky-header' ) ) {
            return;
        }

        if ( scrollTop > 0 ) {
            $( document.body ).addClass( 'active-sticky-header' );
        } else {
            $( document.body ).removeClass( 'active-sticky-header' );
        }
    },

    init: function() {
        var self = this;

        if ( $( document.body ).hasClass( 'hide-sticky-header' ) ) {
            return;
        }

        $( window ).on( 'scroll', function() {
            self.scrollHandler();
        } );
    }
};

export { stickyHeader };